import axios from "axios";
import { OpenAPI } from "@propertelligent/client-api";

// TODO(client-api-regen): Replace this thin axios shim with the generated
// `@propertelligent/client-api` MaintenanceBanner service/types after the backend
// PR merges and CI republishes the SDK.

export enum MaintenanceBannerEntityTypesEnum {
  Organization = 1,
}

export interface MaintenanceBannerVM {
  id?: number;
  title: string;
  messageBody: string;
  startTimeUtc?: string | null;
  endTimeUtc?: string | null;
  entityTypeId?: MaintenanceBannerEntityTypesEnum | null;
  entityId?: number | null;
  created?: string;
  formatted?: Record<string, unknown>;
}

export interface SingleItemResponse<T> {
  success?: T | null;
  errors?: Record<string, string[]>;
}

export interface ListResponse<T> {
  success?: T | null;
  errors?: Record<string, string[]>;
  recordCount?: number;
}

const baseUrl = (): string =>
  typeof OpenAPI.BASE === "string" ? OpenAPI.BASE : "";

const authHeaders = (): Record<string, string> => {
  const token =
    typeof OpenAPI.TOKEN === "string" ? OpenAPI.TOKEN : undefined;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

type AxiosLikeError = {
  message?: string;
  response?: { status?: number; data?: unknown };
};

// The generated `@propertelligent/client-api` throws `ApiError` (with `status` + `body`), and that is
// the shape `apiHelper` reads to surface backend field errors. Raw axios throws `AxiosError` instead,
// so without this normalization every server validation error from these endpoints is swallowed.
const toApiError = (error: unknown): unknown => {
  const axiosError = error as AxiosLikeError;

  if (!axiosError?.response) {
    return error;
  }

  const normalized = new Error(
    axiosError.message || "Request failed",
  ) as Error & { status?: number; body?: unknown };

  normalized.status = axiosError.response.status;
  normalized.body = axiosError.response.data;

  return normalized;
};

const request = async <T>(
  operation: () => Promise<{ data: T }>,
): Promise<T> => {
  try {
    const response = await operation();
    return response.data;
  } catch (error) {
    throw toApiError(error);
  }
};

export const MaintenanceBannerService = {
  getApiMaintenanceBannerActive: async (): Promise<
    SingleItemResponse<MaintenanceBannerVM>
  > => {
    return request(() => axios.get(
      `${baseUrl()}/api/MaintenanceBanner/active`,
      { headers: authHeaders() },
    ));
  },

  getApiMaintenanceBanner: async (): Promise<
    ListResponse<MaintenanceBannerVM[]>
  > => {
    return request(() => axios.get(
      `${baseUrl()}/api/MaintenanceBanner`,
      { headers: authHeaders() },
    ));
  },

  postApiMaintenanceBanner: async (
    payload: MaintenanceBannerVM,
  ): Promise<SingleItemResponse<MaintenanceBannerVM>> => {
    return request(() => axios.post(
      `${baseUrl()}/api/MaintenanceBanner`,
      payload,
      { headers: authHeaders() },
    ));
  },

  putApiMaintenanceBanner: async (
    payload: MaintenanceBannerVM,
  ): Promise<SingleItemResponse<MaintenanceBannerVM>> => {
    return request(() => axios.put(
      `${baseUrl()}/api/MaintenanceBanner`,
      payload,
      { headers: authHeaders() },
    ));
  },

  deleteApiMaintenanceBanner: async (
    id: number,
  ): Promise<SingleItemResponse<string>> => {
    return request(() => axios.delete(
      `${baseUrl()}/api/MaintenanceBanner`,
      {
        headers: authHeaders(),
        params: { id },
      },
    ));
  },
};
